import { useEffect, useState } from 'react';

import { FormFieldValues } from '../components/Form';
import { userService } from '../services';

export interface User {
  isAuthenticated: boolean;
  fieldValues: FormFieldValues;
}

/* globals CSS_CONFIG */
const { UPDATEPROFILECHECKBOX } = CSS_CONFIG;

// TODO: This is same as emptyRecipient in CartContext
const initialUser: User = {
  isAuthenticated: false,
  fieldValues: {
    firstName: '',
    lastName: '',
    streetAddress: '',
    streetAddress2: '',
    streetAddress3: '',
    city: '',
    postCode: '',
    terms: false,
    email: '',
    phoneNumber: '',
    state: '',
    country: '',
    reason: '',
    updateProfileCheckbox: UPDATEPROFILECHECKBOX,
  },
};

interface UserState {
  user: User;
  isLoading: boolean;
}
const useUser = (): UserState => {
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState<User>(initialUser);

  const getCustomer = async (): Promise<void> => {
    try {
      const res = await userService.getCustomer();

      // If user is not logged in we get an *expected* unauthorized error code
      // `companyName` is a string i BE but an object in Reform form.
      if (!res.error && !!res.result) {
        const fieldValues = {
          ...initialUser.fieldValues,
          ...res.result,
        };

        setUser({ isAuthenticated: true, fieldValues });
      }
    } catch {
      // Do stuff
    } finally {
      setIsLoading(false);
    }
  };

  useEffect((): void => {
    getCustomer();
  }, []);

  return { user, isLoading };
};

export default useUser;
